import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DatCatSizeDataItem, upDatCatSizeDataItem, SiteEntry, ColTypeEntry, DatModSizeDataItem, upDatModSizeDataItem, DatModPackageDataItem, upDatModPackageDataItem, PubListEntry } from '../../services/interfaces';
import { saveDatCatSize, deleteDatCatSize, getDatCatSizeList, getDatModSizeList, saveDatModSize, deleteDatModSize, getModPackageList, saveDatPackage, deleteDatPackage } from '../../services/apiAdminService';
import { getStatusList, getSubStatusList } from '../../services/apiService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { ColTypeList, ModColTypeList, PubList, SiteList, StatusList } from '../FormComponents';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

interface PageState {
    skip: number;
    take: number;
}

//const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'category', dir: 'asc' }],
    filter: undefined,
    skip:0,
    take:20
};

interface editProps{
    pkg:DatModPackageDataItem,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewPackage
{
    modCategory:string,
    strIn:string,
    strOut:string,
    tempChar:string,
    newPubNum:number,
    modID:number,
    siteCode:string,
    newCategory:string,
    package:string,
    packageName:string,
    outputTag:string,
    animationPrompt:string,
    product:string,
    webType:string,
    mobile:string,
    tempChar1:string,
    tempInt1:number,
    ExportParameters:string,
    unitName:string,
}


const EditDialog=(props:editProps)=>{
    const userContext = useContext(UserContext);

    const [newPackage, setNewPackage]= useState<NewPackage>(
        {
            modCategory:"",
            strIn:"",
            strOut:"",
            tempChar:"",
            newPubNum:-1,
            modID:0,
            siteCode:"",
            newCategory:"",
            package:"",
            packageName:"",
            outputTag:"",
            animationPrompt:"",
            product:"",
            webType:"",
            mobile:"",
            tempChar1:"",
            tempInt1:0,
            ExportParameters:"",
            unitName:"",
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [selectedSize,setSelectedSize]=useState([]);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");
    const [siteValid, setSiteValid]=useState(false);
    const [outputTags, setOutputTags] = useState([]);
    const [aniPrompts, setAniPrompts] = useState([]);

    const [selSite, setSelSite]=useState<SiteEntry>({
        code:"",
        name:"",
        logo_Prefix:"",
        primary_ip:"",
        backup_ip:"",
        temp_Char:"",
        temp_Int:0,
        vol1_Unc_Path:"",
        vol2_Unc_Path:""
    });
    const [selCategory, setSelCategory]=useState<ColTypeEntry>();
    const [selNewCategory, setSelNewCategory]=useState<ColTypeEntry>();
    const [selPub, setSelPub]=useState<number>()

    const [pkgValid, setPkgValid]=useState({
        siteCode:false,
        modCategory:false,
        strIn:false,
        strOut:false
    });
    
    const setSiteCode=(e: SiteEntry[])=>{
         console.log("Set SelSite");
         console.log(e);
        setSelSite(e[0]);
    }

    async function getOutputTags() {
        const user = userContext?.user;    
        const userDir = "/users/" + user?.username;
        const dashColsPath = userDir + "/outputTags.json";    
        await fetch(dashColsPath)
            .then((response) => response.json())
            .then((data) => setOutputTags(data));
    }

    async function getAniPrompts() {
        const user = userContext?.user;    
        const userDir = "/users/" + user?.username;
        const dashColsPath = userDir + "/animationPrompts.json";    
        await fetch(dashColsPath)
            .then((response) => 
                response.json()
            )
            .then((data) => {
                console.log(data);
                setAniPrompts(data)
            });
    }

    useEffect(()=>{
        console.log("Get Animation Prompts");
        console.log(aniPrompts);
    },[aniPrompts])

    useEffect(()=>{
        console.log("Get Output Tags");
        console.log(outputTags);
    },[outputTags])

    const setSelectedPub=(pub:string[])=>{
        console.log(pub);
        setSelPub(Number(pub[0]));
    }



    const setCategory=(colType: ColTypeEntry[])=>{
        setSelCategory(colType[0]);
    }

    const setNewCategory=(colType: ColTypeEntry[])=>{
        setSelNewCategory(colType[0]);
    }

    const setStrIn=(e: InputChangeEvent)=>{
        setNewPackage({...newPackage, strIn: e.value})
    }

    const setStrOut=(e: InputChangeEvent)=>{
        setNewPackage({...newPackage, strOut: e.value})
    }

    const setDisplayName=(e: InputChangeEvent)=>{
        setNewPackage({...newPackage, packageName: e.value})
    }

     const setWebType=(e: InputChangeEvent)=>{
        setNewPackage({...newPackage, webType: e.value})
    }

    const setAniPrompt=(e: DropDownListChangeEvent)=>{
        setNewPackage({...newPackage, animationPrompt: e.value.name})
    }
    
    const setOutputTag=(e: DropDownListChangeEvent)=>{
        setNewPackage({...newPackage, outputTag: e.value.name})
    }

    const setPubType=(e: DropDownListChangeEvent)=>{
        setNewPackage({...newPackage, tempChar: e.value})
    }

    const setPackage=(e: SwitchChangeEvent)=>{
        setNewPackage({...newPackage, package: e.value===true?"Y":"N"})
    }

    const setMobile=(e: SwitchChangeEvent)=>{
        setNewPackage({...newPackage, mobile: e.value===true?"Y":"N"})
    }


    const validatePkg= async()=>{
        var pkgValid={
            siteCode:false,
            modCategory:false,
            strIn:false,
            strOut:false
        }
        if (newPackage.modCategory!=""){
            pkgValid.modCategory=true;
        }
        if (newPackage.siteCode!==""){
            pkgValid.siteCode=true;
        }
        if (newPackage.strIn!==""){
            pkgValid.strIn=true;
        }
        if (newPackage.strOut!==""){
            pkgValid.strOut=true;
        }
        setPkgValid(pkgValid);
       return (pkgValid);
    }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }

    const deleteThisPkg=()=>{
        if (props.action=="Edit"){
            const category = newPackage.modCategory;
            const site = newPackage.siteCode;
            const strIn = newPackage.strIn;
            const strOut = newPackage.strOut;
            const modID = newPackage.modID;
            if (site!="" && category!="" && strIn!="" && strOut!=""){
               deleteDatPackage(category,site,strIn, strOut, modID);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }



    const saveThisPkg= async ()=>{

        var oCategory;
        var oStrIn;
        var oStrOut;
        var oModId;
        var ositeCode;
        console.log(newPackage);
        validatePkg().then((pkgValid)=>{
             if (pkgValid.modCategory===true && pkgValid.siteCode===true && pkgValid.strIn===true && pkgValid.strOut===true){
                 if (intAction==="Edit"){
                    //edit existing pub
                    oCategory=props.pkg.modCategory;
                    oStrIn=props.pkg.strIn;
                    oStrOut=props.pkg.strOut;
                    ositeCode=props.pkg.siteCode;
                    oModId=props.pkg.modID;
                 }else{
                     //create new pub
                    oCategory="";
                    oStrIn="";
                    ositeCode="";
                    oStrOut="";
                    oModId=0;
                 }
                 var formData:upDatModPackageDataItem = {
                    oModCategory: oCategory,
                    oStrIn:oStrIn,
                    oStrOut:oStrOut,
                    oModId:oModId,
                    oSiteCode:ositeCode,
                    modCategory:newPackage.modCategory,
                    siteCode: newPackage.siteCode,
                    strIn:newPackage.strIn,
                    strOut:newPackage.strOut,                    
                    tempChar:newPackage.tempChar,
                    newPubNum:newPackage.newPubNum,
                    modID:newPackage.modID,
                    newCategory:newPackage.newCategory,
                    package:newPackage.package,
                    packageName:newPackage.packageName,
                    outputTag:newPackage.outputTag,
                    animationPrompt:newPackage.animationPrompt,
                    product:newPackage.product,
                    webType:newPackage.webType,
                    mobile:newPackage.mobile,
                    tempChar1:newPackage.tempChar1,
                    tempInt1:newPackage.tempInt1,
                    ExportParameters:newPackage.ExportParameters,
                    unitName:newPackage.unitName
                  };
                 console.log(formData);
                 saveDatPackage(formData).then((data)=>{
                     console.log(data);
                     props.onClose();
                 });    
             }else{
                 console.log("Missing fields");
             }    
        });
        
    }

    useEffect(()=>{
        if (selSite && selSite.code){
            setNewPackage({...newPackage, siteCode: (selSite.code) || ''})  
        }
    },[selSite])

    useEffect(()=>{
        if (selCategory && selCategory.category!==""){
            setNewPackage({...newPackage, modCategory: (selCategory.category)})
        }
    },[selCategory])

    useEffect(()=>{
        if (selPub){
            setNewPackage({...newPackage, newPubNum: (Number(selPub))})
        }
    },[selPub])

    useEffect(()=>{
        if (selNewCategory && selNewCategory.category!==""){
            setNewPackage({...newPackage, newCategory: (selNewCategory.category)})
        }
    },[selNewCategory])

    useEffect(()=>{
        console.log("New Package Updated");
        console.log(newPackage);
        setSelPub(newPackage.newPubNum)
        validatePkg();
    },[newPackage])


    useEffect(() => {  
        setDlgTitle(props.title);
        if (props.pkg){
            setNewPackage({
                modCategory:props.pkg.modCategory,
                strIn:props.pkg.strIn,
                strOut:props.pkg.strOut,
                tempChar:props.pkg.tempChar,
                newPubNum:props.pkg.newPubNum,
                modID:props.pkg.modID,
                siteCode:props.pkg.siteCode,
                newCategory:props.pkg.newCategory,
                package:props.pkg.package,
                packageName:props.pkg.packageName,
                outputTag:props.pkg.outputTag,
                animationPrompt:props.pkg.animationPrompt,
                product:props.pkg.product,
                webType:props.pkg.webType,
                mobile:props.pkg.mobile,
                tempChar1:props.pkg.tempChar1,
                tempInt1:props.pkg.tempInt1,
                ExportParameters:props.pkg.ExportParameters,
                unitName:props.pkg.unitName
            });
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewDeleteButton();
        }else{
            hideDeleteButton();
        }
        getAniPrompts();
        getOutputTags();
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"90vh"}>
            {showDelConfirm?<ConfirmDialog title='Delete Sub-status Entry' message='This will permanently delete the selected sub-status entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisPkg}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Site:</Label></Col>
                <Col xs="9"><SiteList value={newPackage.siteCode} setReturnAction={setSiteCode} multi={false} valid={pkgValid.siteCode} className="" ></SiteList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Modular Type:</Label></Col>
                <Col xs="9"><ModColTypeList setReturnAction={setCategory} value={newPackage.modCategory} site={selSite} className={'formField '} valid={pkgValid.modCategory} /></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Order Size:</Label></Col>
                <Col xs="9"><Input value={newPackage.strIn} onChange={setStrIn} valid={pkgValid.strIn}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Build Size:</Label></Col>
                <Col xs="9"><Input value={newPackage.strOut} onChange={setStrOut} valid={pkgValid.strOut}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Pub Type:</Label></Col>
                <Col xs="9"><DropDownList data={["PRINT","ONLINE"]} value={newPackage.tempChar} onChange={setPubType}fillMode={"outline"}></DropDownList></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>New Ad Type:</Label></Col>
                <Col xs="9"><ModColTypeList setReturnAction={setNewCategory} value={newPackage.newCategory} valid={true} site={selSite} className={''} ></ModColTypeList></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>New Pub:</Label></Col>
                <Col xs="9"><PubList setReturnAction={setSelectedPub} value={[selPub?.toString()||""]} type={"single"} archiveOnly={false} liveOnly={true} siteFilter={selSite.code} className={''} returnField={''} onlineOnly={false} printOnly={false} same={true}></PubList></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Package Name:</Label></Col>
                <Col xs="9"><Input value={newPackage.packageName} onChange={setDisplayName}></Input></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Output Tag:</Label></Col>
                <Col xs="9"><DropDownList data={outputTags} textField='name' dataItemKey='name' value={{name:newPackage.outputTag}} fillMode={"outline"} onChange={setOutputTag}/></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Animation Prompt:</Label></Col>
                <Col xs="9"><DropDownList data={aniPrompts} textField='name' dataItemKey='name' value={{name:newPackage.animationPrompt}} fillMode={"outline"} onChange={setAniPrompt}/></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Web Type:</Label></Col>
                <Col xs="9"><Input value={newPackage.webType} onChange={setWebType}></Input></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={newPackage.package=="Y"?true:false} onChange={setPackage}></Switch>&emsp;<Label className='mb-2'>Package</Label></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={newPackage.mobile=="Y"?true:false} onChange={setMobile}></Switch>&emsp;<Label className='mb-2'>Mobile</Label></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisPkg}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminModPackages (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [site, setSite] = useState<SiteEntry>({
        code:"",
        name:"",
        logo_Prefix:"",
        primary_ip:"",
        backup_ip:"",
        temp_Char:"",
        temp_Int:0,
        vol1_Unc_Path:"",
        vol2_Unc_Path:""
    });

    const [colType, setColType]= useState<ColTypeEntry[]>([{
        type:"",
        category:"",
        display:"",
        site:"",
        specView:""
    }])

    const [packages, setPackages] = useState([]);
    const [pkgSelected, setPkgSelected]=useState<DatModPackageDataItem>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(packages,dataState));
    //const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    function setSearchSite(selSite:SiteEntry[]){
        //console.log(site);
        setSite(selSite[0]);
    }

    function setSearchColType(selType:ColTypeEntry[]){
        //console.log(site);
        setColType(selType);
    }
    const idGetter = getter('pubNum');

    const setSelectedSubStat=(size:DatModPackageDataItem)=>{
        setPkgSelected(size);
    }

    const hideEditDialog=()=>{
        setShowEditDialog(false);
        if (site.code!==""){
            getModPackages();
        }
    }

    const openEditDiaglog=()=>{
        setShowEditDialog(true);
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        setTitle("New Package");
        setPkgSelected( {
            modCategory:"",
            strIn:"",
            strOut:"",
            tempChar:"",
            newPubNum:-1,
            modID:0,
            siteCode:"",
            newCategory:"",
            package:"",
            packageName:"",
            outputTag:"",
            animationPrompt:"",
            product:"",
            webType:"",
            mobile:"",
            tempChar1:"",
            tempInt1:0,
            ExportParameters:"",
            unitName:"",
        })
        setShowEditDialog(true);
    }



    const getModPackages=()=>{
        getModPackageList(site.code).then(data=>{
            console.log(data);
            setPackages(data);
            //setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        //setDataResult(process(packages, e.dataState));
    };

    const processedData=process(packages,dataState);

    // const pageChange = (event: GridPageChangeEvent) => {
    //     const targetEvent = event.targetEvent as PagerTargetEvent;        
    //     setPage({
    //         ...event.page,
    //         take:20
    //     });
    // }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const pkg:DatModPackageDataItem=event.startDataItem;
        setPkgSelected(pkg);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "category"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        console.log(pkgSelected);
        if (pkgSelected){
            setTitle("Configure Modular Package");
            setAction("Edit");
            openEditDiaglog();
        }
    },[pkgSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            if (site.code!==""){
                getModPackages();
            }
        }else{
            window.location.replace("/Login");
        }
    }, [site]);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Package Management</h2>
            <Toolbar>
                <SiteList value={site} setReturnAction={setSearchSite} multi={false} className='toolbarField' valid={true}></SiteList>
                <Button title="New Package" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Size
                </Button>       
            </Toolbar>
            <Grid
                data={processedData}
                // data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                //     ...item, 'selected':selectedState[idGetter(item)]
                // }))}
                dataItemKey='UID'
                id="sizeGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                // onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                // skip={page.skip}
                // take={page.take}
                // total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='modCategory' title='Category'/>
                <GridColumn field='modID' title='Mod ID'/>
                <GridColumn field='strIn' title='Order Size'/>
                <GridColumn field='strOut' title='Actual Size'/>
                <GridColumn field='siteCode' title='Site' width={150} filterable={false} />
                <GridColumn field='newCategory' title='New Category'/>
                <GridColumn field='newPubNum' title='New Pub'/>
                <GridColumn field='packageName' title='Package'/>
                <GridColumn field='product' title='Product'/>
            </Grid>
            {showEditDialog?
                <EditDialog title={title} pkg={pkgSelected as DatModPackageDataItem} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}